import FEATURES from '../constants/features.js';

export default {
  [FEATURES.ADVANCED_FILTERING]: true
};
